import _ from 'lodash';
import dayjs from 'dayjs';

/**
 * Function returns detailed car rental data
 */
const getDetailedCarData = (carDetails, currencySign) => {
  const {
    carDetails: details, policyInfo, priceInfo, locationInfo,
  } = carDetails;

  let data = 'Car rental details:\n';
  data += `Vehicle: ${details.vehicle}\n`;
  data += `Car Class: ${details.carClass}\n`;
  data += `Seats: ${details.seats}\n`;
  data += `Doors: ${details.doors || 'N/A'}\n`;
  data += `Bags: ${details.bags}\n`;
  _.each(details.bagInfos, (bag) => {
    data += `- ${bag.size} Bags: ${bag.quantity}\n`;
  });
  data += `Manual: ${details.manual ? 'Yes' : 'No'}\n`;
  data += `Air Conditioning: ${details.airConditioning ? 'Yes' : 'No'}\n`;
  data += `Pick-up Location: ${locationInfo.pickUpAddress}\n`;
  data += `Drop-off Location: ${locationInfo.dropOffAddress}\n`;
  data += `Pick-up counter location name: ${locationInfo.pickUpCounterLocationName && locationInfo.pickUpCounterLocationName}\n`;
  data += `Drop-off counter location name: ${locationInfo.dropOffCounterLocationName && locationInfo.dropOffCounterLocationName}\n`;
  data += `Pick-up Time: ${dayjs(carDetails.pickUpDateTime).format('MMM D, YYYY h:mm A')}\n`;
  data += `Drop-off Time: ${dayjs(carDetails.dropOffDateTime).format('MMM D, YYYY h:mm A')}\n`;

  data += '\nPolicy Information:\n';
  data += `Fuel Policy: ${policyInfo.fuelPolicy || 'N/A'}\n`;
  data += `Fair Fuel Policy: ${policyInfo.isFairFuelPolicy ? 'Yes' : 'No'}\n`;
  data += `Unlimited Mileage: ${policyInfo.unlimitedMileage ? 'Yes' : 'No'}\n`;
  data += `Free Cancellation: ${policyInfo.freeCancellation ? 'Yes' : 'No'}\n`;
  data += `Mandatory Chauffeur: ${policyInfo.mandatoryChauffeur ? 'Yes' : 'No'}\n`;
  data += `Additional Drivers Allowed: ${policyInfo.additionalDrivers ? 'Yes' : 'No'}\n`;

  data += '\nPrice Information:\n';
  data += `Total Price: ${currencySign}${priceInfo.priceAllDays}\n`;
  _.each(priceInfo.vehicleCharges, (charge) => {
    data += `- ${charge.chargeType}: ${currencySign}${charge.amount}\n`;
  });

  return data;
};

export default getDetailedCarData;
